import type { Component } from 'vue'
import type { ContentBlock } from './contentBlock.types'

import VContentFallback from './blocks/VContentFallback.vue'

import VContentBlockLayout from './blocks/VContentBlockLayout.vue'

/**
 * Мапа типів блоків (landing + office numeric / `html`).
 * Відповідає `elements.types.ts` + `elements.views.ts` у bibleawr-office2.ui.
 */
const CONTENT_COMPONENTS: Record<string, Component> = {
  '61': VContentBlockLayout,
}

export function resolveContentComponent(block: ContentBlock): Component {
  const raw = String(block.type ?? '')
  return CONTENT_COMPONENTS[raw] ?? VContentFallback
}

export function getContentBindings(block: ContentBlock, showAnswers: boolean): { block: ContentBlock; showAnswers?: boolean } {
  void showAnswers
  return { block }
}
